import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TreeNavigation, TreeNavigationItem, TreeNavigationDropdown } from '../../common';
import SubscriptionRequest from '../../../models/entities/SubscriptionRequest';
import SubscriptionRequestsService from '../../../services/SubscriptionRequestsService';
import moment from 'moment';

interface SubscriptionsHomeActionsRowProps {
	subscription: SubscriptionRequest;
	seePermissionsReport: (sub: SubscriptionRequest) => void;
	setModalVisibleDomainOperation: (visible: boolean) => any;
	handleAttestModal: (sub: SubscriptionRequest) => void;
	setSubId: (subId: number) => void;
	setSubType: (subType: boolean) => void;
}

const SubscriptionsHomeActiosnRow = ({ subscription, seePermissionsReport, setModalVisibleDomainOperation, handleAttestModal, setSubId, setSubType }: SubscriptionsHomeActionsRowProps) => {
	const navigate = useNavigate();

	const handleDomainOperationModal = () => {
		setSubId(subscription?.id)
		setModalVisibleDomainOperation(true);
		setSubType(subscription?.isConnected)
	}

	const needsAttestation = () => {
		if (!subscription.lastAttestationDate) return true;
		
		const twelveMonthsAgo = moment().subtract(12, 'months');
		const lastAttestation = moment(subscription.lastAttestationDate);
		
		return lastAttestation.isBefore(twelveMonthsAgo);
	};

	return (
		<TreeNavigation>
			{subscription.cansSeePermissionsReport() && (
				<TreeNavigationItem textColor="primary" label="Permissions Report" onClick={() => seePermissionsReport(subscription)} />
			)}
			{subscription?.canSeeAttestRequest() && needsAttestation() && (
				<TreeNavigationItem
					textColor="primary"
					label="Attest"
					onClick={() => handleAttestModal(subscription)}
				/>
			)}
			{subscription?.canSeePortOpeningRequests() && (
				<TreeNavigationDropdown textColor='primary' label="Port Opening Requests">
					{subscription.canSubmitPortOpeningRequests() && (
						<TreeNavigationItem
							textColor="primary"
							label="Create a Request"
							onClick={() => navigate(`/subscriptions/${subscription?.id}/portOpeningRequest/new`)}
						/>
					)}
					<TreeNavigationItem
						textColor="primary"
						label="Request History"
						onClick={() => navigate(`/subscriptions/${subscription?.id}/PortOpeningRequestsHistory`)}
					/>
				</TreeNavigationDropdown>
			)}
			{subscription?.canSeeDNDRequests() && ( //TODO: change to canSeeDoNotDecryptRequest
				<TreeNavigationDropdown textColor='primary' label="DPI (Deep Packet Inspection) / SSL Exception Requests" optionalClass="submenu">
					{subscription.canSubmitPortOpeningRequests() && (
						<TreeNavigationItem
							textColor="primary"
							label="Create a Request"
							onClick={() => navigate(`/subscriptions/${subscription?.id}/doNotDecryptRequests/new`)}
						/>
					)}
					<TreeNavigationItem
						textColor="primary"
						label="Request History"
						onClick={() => navigate(`/subscriptions/${subscription?.id}/doNotDecryptRequestsHistory`)}
					/>
				</TreeNavigationDropdown>
			)}
			{subscription?.canSeePolicyExemptionRequests() && (
				<TreeNavigationDropdown textColor='primary' label="Policy Exception Requests">
					<TreeNavigationItem
						textColor="primary"
						label="Create a Request"
						onClick={() =>
							navigate('/subscriptions/policy-request/new', {
								state: { preselectedSubscription: subscription },
							})
						}
					/>
					<TreeNavigationItem
						textColor="primary"
						label="Request History"
						onClick={() => navigate(`/subscriptions/${subscription?.id}/PolicyExemptionRequests`)}
					/>
				</TreeNavigationDropdown>
			)}
			{subscription?.canSeeSubscriptionAdminConsent() && (
				<TreeNavigationItem
				  	textColor="primary"
					label="Graph API Admin Consent"
					onClick={() => navigate(`/subscriptions/${subscription?.id}/adminConsent`)}
				/>
			)}
			{subscription.canSeeSubscriptionDomainOperation() && (
				<TreeNavigationItem
					textColor="primary"
					label="Request Domain Operation"
					onClick={() => handleDomainOperationModal()}
				/>
			)}
		</TreeNavigation>
	);
};

export default SubscriptionsHomeActiosnRow;
